import { css } from 'aphrodite';
import { useMemo } from 'react';
import { FormState } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../../web/components/Select';
import { IDonationSurvey } from '../../../../models/Api';
import { ErrorMessage } from '../CustomerDataCollection/ErrorMessage';
import { IFormValues } from '../utils';
import { styleSheet } from './style';

type IProps = {
	survey: IDonationSurvey;
	formValues: IFormValues;
	setValue: (name: keyof IFormValues, value: string | number | boolean) => void;
	formState: FormState<IFormValues>;
};

export const SpecificCauseSelector = ({ survey, formValues, setValue, formState }: IProps) => {
	const campaignOptions = useMemo(() => {
		return [
			{
				value: null,
				label: '---',
			},
			...(survey.availableCampaigns?.map(campaign => ({
				value: campaign.id,
				label: campaign.name,
			})) || []),
		];
	}, [survey]);

	if (!survey.availableCampaigns || survey.availableCampaigns?.length === 0) {
		return null;
	}

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.textContainer)}>
				<p className={css(styleSheet.subtitle)}>Select Specific Cause</p>
			</div>
			<div className={css(styleSheet.selectContainer)}>
				<Select
					items={campaignOptions}
					name='campaignId'
					value={formValues.campaignId || ''}
					onValueChange={value => {
						setValue('campaignId', value);
					}}
				>
					<SelectTrigger>
						<SelectValue placeholder='Select Donation Causes' />
					</SelectTrigger>
					<SelectContent>
						{campaignOptions?.map(campaign => (
							<SelectItem key={campaign.value} value={campaign.value}>
								{campaign.label}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
				{formState?.errors?.campaignId && <ErrorMessage message={formState.errors.campaignId.message} />}
			</div>
		</div>
	);
};
